/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  InfoOverlayContentContainer
 */

import { hocCompose } from '@zcode/react-utils'
import { routerConnect } from '@zcode/router-connect'
import type { RouteComponentProps } from '@zcode/router-utils'
import type { Listable, State } from '@zcode/state-type'
import { connect } from 'react-redux'
import { getVerticalsArray } from '../../../../../../inspectors/index'
import { selectAdditionalBuildingData } from '../../../../../../modules/currentSearch/selectors/index'
import { selectIsCFR } from '../../../../../../modules/router/selectors/index'
import { InfoOverlayContentInnerContainer } from './InfoOverlayContentInnerContainer'

export const mapRouteToProps = (routeProps: RouteComponentProps) => {
  return {
    isCFR: selectIsCFR(routeProps),
    verticalsArray: getVerticalsArray(routeProps),
  }
}

export interface OwnProps {
  listable: Listable
}

export const mapStateToProps = (state: State, { listable }: OwnProps) => {
  return {
    additionalBuildingData: selectAdditionalBuildingData(state, listable.buildingId),
  }
}

export const InfoOverlayContentContainer = hocCompose(
  routerConnect(mapRouteToProps, { forwardRouteProps: true }),
  connect(mapStateToProps, {}),
  InfoOverlayContentInnerContainer
)
